import { View, Plugin } from 'shared/domains/pleditor@next';
export class FlexGap extends Plugin {
    static get pluginName() {
        return 'FlexGap';
    }
    init() {
        const { editor } = this;
        editor.ui.componentFactory.add('<->', () => {
            const view = new View();
            view.setTemplate({
                tag: 'div',
                attributes: { class: 'ck-flex-gap' },
            });
            return view;
        });
    }
}
